import React from "react";
import errorIcon from "../../../assets/images/red-alert-icon.png";
import "./RenderInputError.scss";
import { Error } from '@mui/icons-material';

const RenderInputError = (props: { errorLabel?: string, id?:string, isSuspendLabel?: boolean | null ,inputLabel?: string, style?:{}}) => {
  return (
    <>
      <div className="d-flex align-items-center render-input-error-wrapper" style={props.style ?? props.style} >
       {props.errorLabel ?  <Error style={{ fontSize: '18px',color: "#94252a" }} /> : " "} 
        <span id={`${props.id}-sr`} aria-describedby={props?.id || ""} aria-relevant="all">{props.errorLabel} <span className="visually-hidden"> -{props.inputLabel}</span></span>
      </div>
    </>
  );
};

export default RenderInputError;
